export default "__VITE_ASSET__DfiKIXlw__"